import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SubjectItem = ({ nameItem, img, mail, subject }) => {
  const { t } = useTranslation();

  switch (nameItem) {
    case 'notebook':
      return (
        <Link className="subject-item" to={`/notebook/${mail}/${subject}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'homework':
      return (
        <Link className="subject-item" to={`/student-homework-list/${subject}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'materials':
      return (
        <Link className="subject-item" to={`/student-materials/${nameItem}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'materials-subjects':
      return (
        <Link className="subject-item" to={`/student-materials/materials/${subject}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'books':
      return (
        <Link className="subject-item" to={`/student-materials/${nameItem}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'exams':
      return (
        <Link className="subject-item" to={`/student-materials/${nameItem}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'exams-tab':
      return (
        <Link className="subject-item" to={`/student-materials/${nameItem}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'homeworks':
      return (
        <Link className="subject-item" to={`/student-materials/${nameItem}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
    case 'notebooks':
      return (
        <Link className="subject-item" to={`/student-materials/${nameItem}`}>
          <div className="subject-homework subject-image">
            <img src={img} alt={nameItem} />
          </div>

          <span className="subject-text">
            {t(nameItem)}
            <span className="icon-Arrow-right-tall"></span>
          </span>
        </Link>
      );
  }
};

export default SubjectItem;
